import TextFieldMui, { TextFieldProps } from "@mui/material/TextField"
import "./index.scss"

export const TextField = (props: TextFieldProps) => (
  <TextFieldMui className="custom-input" {...props} />
)
